import {requestService} from "./RequestService";
import {ApiRoutes} from "../routes/ApiRoutes";

export const CounterApi = {
    /**
     * Fetches the sidebar counter data.
     * @returns {Promise<object>} Promise resolving to an object containing sidebar counter data.
     */
    getSidebarCounter: async (): Promise<Record<string, number>> => {
        if (!ApiRoutes.COUNTER_SIDEBAR_ENDPOINT) {
            throw new Error("COUNTER_SIDEBAR_ENDPOINT is not defined");
        }

        const response = await requestService.get(ApiRoutes.COUNTER_SIDEBAR_ENDPOINT, {});

        return response.data as Record<string, number>;
    },
    /**
     * Fetches the sitemap counter data.
     * @returns {Promise<Record<string, number>>} Promise resolving to a record of string keys and number values.
     */
    getSitemapCounter: async (): Promise<Record<string, number>> => {
        if (!ApiRoutes.COUNTER_SITEMAP_ENDPOINT) {
            throw new Error("COUNTER_SITEMAP_ENDPOINT is not defined");
        }

        const response = await requestService.get(ApiRoutes.COUNTER_SITEMAP_ENDPOINT, {});

        return response.data as Record<string, number>;
    }
};